import { ReactNode } from 'react'
import { Style, styled } from 'inlines'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowRight, faArrowLeft } from '@fortawesome/pro-regular-svg-icons'
import { Text } from '../typography/Text'
import {
  Size,
  linkStyle,
  linkSizeStyle,
  linkIconSizeStyle,
} from './linkStyleHeper'
import { Link as RouterLink } from 'wouter'

export type TextLinkProps = {
  children: ReactNode
  to: string
  externalURL?: boolean
  size?: Size
  isBold?: boolean
  hasIcon?: boolean
  iconPosition?: 'left' | 'right'
  noHover?: boolean
  target?: string
  textStyle?: Style
  containerStyle?: Style
}

export const TextLink = ({
  children,
  to,
  externalURL = false,
  size = 'medium',
  isBold = false,
  hasIcon = false,
  iconPosition = 'right',
  noHover = false,
  target = '',
  textStyle,
  containerStyle,
}: TextLinkProps) => {
  const text = (
    <Text.Medium
      key="text"
      style={{
        fontWeight: isBold ? 600 : 500,
        ...linkSizeStyle[size],
        ...textStyle,
      }}
    >
      {children}
    </Text.Medium>
  )
  const content = [text]

  if (hasIcon) {
    if (iconPosition === 'right') {
      content.push(
        <FontAwesomeIcon
          key="icon"
          icon={faArrowRight}
          style={{ ...linkIconSizeStyle[size] }}
        />,
      )
    } else {
      content.unshift(
        <FontAwesomeIcon
          key="icon"
          icon={faArrowLeft}
          style={{ ...linkIconSizeStyle[size] }}
        />,
      )
    }
  }

  const style = linkStyle
  if (noHover) {
    style['&:hover'] = { opacity: '0.65' }
  }

  if (externalURL) {
    return (
      <styled.a
        href={to}
        style={{ ...style, ...containerStyle }}
        target={target}
      >
        {content}
      </styled.a>
    )
  }

  return (
    <RouterLink href={to} target={target}>
      <styled.div style={{ ...style, ...containerStyle }}>{content}</styled.div>
    </RouterLink>
  )
}
